import { ReactNode } from 'react';

/**
 * Separates react nodes with a given separator.
 *
 * @param nodes The nodes to separate.
 * @param options The options.
 */
export function separateReactNodes(
  nodes: readonly ReactNode[],
  options: SeparateReactNodesOptions,
): readonly ReactNode[] {
  const { separator, nodeTransformFn = (node) => node } = options;
  return nodes
    .map((node, index) => {
      const currentNode = nodeTransformFn(node, index, nodes);
      return index === nodes.length - 1
        ? currentNode
        : [currentNode, separator];
    })
    .flat();
}

/** Represents the options of {@link separateReactNodes}. */
export type SeparateReactNodesOptions = {
  /** The separator element. */
  separator: ReactNode;
  /** The callback function for transforming the nodes. */
  nodeTransformFn?: SeparateReactNodesTransformFn;
};

/**
 * Represents the function for transforming a node when performing separation of
 * nodes.
 */
export type SeparateReactNodesTransformFn = (
  node: ReactNode,
  index: number,
  nodes: readonly ReactNode[],
) => ReactNode;
